import { render, staticRenderFns } from "./rateGrade.vue?vue&type=template&id=6b5cecbc&scoped=true&"
import script from "./rateGrade.vue?vue&type=script&lang=js&"
export * from "./rateGrade.vue?vue&type=script&lang=js&"
import style0 from "./rateGrade.vue?vue&type=style&index=0&id=6b5cecbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5cecbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b5cecbc')) {
      api.createRecord('6b5cecbc', component.options)
    } else {
      api.reload('6b5cecbc', component.options)
    }
    module.hot.accept("./rateGrade.vue?vue&type=template&id=6b5cecbc&scoped=true&", function () {
      api.rerender('6b5cecbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/components/rateGrade.vue"
export default component.exports